import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_SEARCH_DOLLAR: GlameraIconDefinition = {
  name: 'search-dollar',
  viewBox: '0 0 24 24',
  svg: `
    <g class="glm-search-dollar-group">
      <circle class="glm-search-dollar-lens" cx="11" cy="11" r="8"></circle>
      <path class="glm-search-dollar-handle" d="m21 21-4.34-4.34"></path>
      <g class="glm-search-dollar-sign">
        <path d="M13.5 8.5h-3.5a1.5 1.5 0 0 0 0 3h2a1.5 1.5 0 0 1 0 3H8.5"></path>
        <path d="M11 7v1.25M11 17v-1.25"></path>
      </g>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-search-dollar-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './search-dollar.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class SearchDollarIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_SEARCH_DOLLAR;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
